import { render, staticRenderFns } from "./invoiceImport.vue?vue&type=template&id=ca44949c&"
import script from "./invoiceImport.vue?vue&type=script&lang=js&"
export * from "./invoiceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports